import PropTypes from 'prop-types'

const InnerText = ({ text }) => (
  <span dangerouslySetInnerHTML={{ __html: text }} /> // eslint-disable-line react/no-danger
)

export default InnerText

InnerText.propTypes = {
  text: PropTypes.string.isRequired
}
